<template>
  <div class="text">
    <v-container class="pa-0">

      <div class="padding-15-no-bottom background-white">
        <h1 v-if="hasNext">Instructies ({{ currentStep+1 }}): <small>{{ title }}</small></h1>
        <h1 v-if="!hasNext" style="text-align:center">{{ title }}</h1>
      <v-progress-linear
          v-model="progress"
          height="15"
          class="rounded-progress"
          color="accent"
          v-if="hasNext"
      ></v-progress-linear>
      </div>
      <v-tabs
          v-model="currentStep"
          show-arrows
          dark
          ref="content"
      >

        <v-tab
            v-for="step in steps"
            :key="step.id"
            ripple
        >{{ step.title }}
        </v-tab>
        <v-tab-item
            v-for="step in steps"
            :key="step.id"
        >
          <v-layout row wrap >
            <v-flex xs12>
              <v-card flat class="padding-16 background-white" v-if="headerImage || headerVideo">
                <v-img v-if="headerImage" :src="headerImage"></v-img>
                <div v-html="headerVideo" v-if="headerVideo"></div>
              </v-card>
              <v-card class="pa-0" flat color="#EDEFF0">
                <v-card-text>
                  <div v-html="step.content"></div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-tab-item>

      </v-tabs>


    </v-container>
    <v-footer fixed color="white" height="auto" :class="{'background-white':!hasNext}" ref="footer">
      <v-container class="pa-0" fluid style="padding-top: 0">
        <v-layout row wrap>
          <v-flex xs5 v-if="hasPrev && hasNext">
            <v-btn  block color="blue" dark class="v-btn--prev--next" @click="prev"><i class="rotate-90 icon icon-kruidvat-arrow icon-white"></i> Vorige</v-btn>
          </v-flex>
          <v-flex :xs7="hasPrev" :xs12="!hasPrev" v-if="hasNext">
            <v-btn  block color="blue" dark class="v-btn--prev--next" @click="next">Volgende <i class="icon icon-kruidvat-arrow icon-white"></i></v-btn>
          </v-flex>
          <!--<v-flex xs12 v-if="!hasNext">-->
            <!--<v-btn  block color="#e32219" dark @click="resetStep">Opnieuw</v-btn>-->
          <!--</v-flex>-->
          <v-flex xs12>
            <v-btn v-if="!hasNext" dark color="accent" class="v-btn--create-photo" style="margin:15px 0 25px 40px;" round @click="$router.push('/photo')">Pasfoto maken <i class="icon icon-kruidvat-arrow icon-white"></i></v-btn>
            &nbsp;
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
  import BackendService from "@/services/BackendService";

  export default {
    data: () => {
      return {
        headerImage: '',
        headerVideo: '',
        currentStep: null,
        title: '',
        content: '',
        steps: [],
      }
    },
    created() {
      this.fetchData()
    },
    mounted() {
      this.$nextTick(() => {
        this.addFooterPadding();
        window.addEventListener('resize',this.resizeVideo);
        window.addEventListener('resize',this.addFooterPadding);
      });
      // this.resetStep();
    },
    updated() {
      this.addFooterPadding();
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchData',
      currentStep: function() {
        let data = this.steps[this.currentStep];
        this.headerVideo = '';
        this.headerImage = '';
        this.title = data.title;
        this.content = data.content;
        if (data.video) {
          let ytid = this.getYoutubeId(data.video);
          this.headerVideo = "<iframe style='width:100%' src=\"https://www.youtube.com/embed/" + ytid + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>"
          this.$nextTick(() => {
            this.resizeVideo();
          });
        } else if (data.image) {
          this.headerImage = data.image;
        }
      }
    },
    computed: {
      hasNext: function() {
        return this.currentStep + 1 < this.steps.length;
      },
      hasPrev: function() {
        return this.currentStep > 0;
      },
      progress: function() {
        return Math.round(((this.currentStep+1) / this.steps.length) * 100);
      }
    },
    methods: {
      fetchData() {
        BackendService.getTextsByKey('step')
          .then((response) => {
            this.steps = response.data;
            this.currentStep = 0;
            setTimeout(this.addFooterPadding,500);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      next() {
        if (this.currentStep < this.steps.length) {
          this.currentStep = this.currentStep + 1;
        }
      },
      prev() {
        if (this.currentStep > 0) {
          this.currentStep = this.currentStep - 1;
        }
      },
      resetStep() {
        this.currentStep = 0;
      },
      getYoutubeId(url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regExp);

        if (match && match[2].length == 11) {
          console.log('Found Youtube ID',match[2]);
          return match[2];
        } else {
          console.log('Found NO Youtube ID');
          return 'error';
        }
      },
      resizeVideo() {
        let video = document.getElementById('video');
        if (video !== null) {
          let videoWidth = video.offsetWidth;
          let h = videoWidth / 16 * 9;
          video.style.height = h + 'px';
        }
      },
      addFooterPadding() {
        if (this.$refs.content) {
          let content = this.$refs.content.$el;
          let footerHeight = this.$refs.footer.$el.offsetHeight;
          if (content.offsetHeight > window.innerHeight - 80 - footerHeight) {
            content.style.paddingBottom = (footerHeight + 20) + 'px';
          }
        }
      }
    }
  }
</script>

<style>
  .v-tabs__bar {
    display: none !important;
  }

  .v-progress-linear {
    border: 2px solid #e32219;
  }

  .v-progress-linear__background {
    opacity: 0!important;
  }

  .rounded-progress {
    border-radius: 10px;
    margin-bottom: 0px!important;
    padding-bottom: 14px!important;
  }

</style>